import React from "react";
import { useTranslation } from "react-i18next";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ButtonMAS from "ButtonMAS/ButtonMAS";
import s from "./SearchFieldButtonBar.module.scss";

const SearchFieldButtonBar = ({
  loading,
  collapse,
  handleCollapse,
  resetBtn,
  handleReset,
  searchBtn,
  handleSearch,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s.searchFieldBtnBar}>
      {
        <div style={{ display: collapse != undefined ? "block" : "none" }}>
          {collapse ? (
            <ButtonMAS
              className={[s.expandBtn, s.functionalBtn].join(" ")}
              variant="bordered"
              onClick={() => handleCollapse(false)}
            >
              {t("component.searchField.title.expand")}
              <ExpandMoreIcon sx={{ fontSize: 18 }} />
            </ButtonMAS>
          ) : (
            <ButtonMAS
              className={[s.expandBtn, s.functionalBtn].join(" ")}
              variant="bordered"
              onClick={() => handleCollapse(true)}
            >
              {t("component.searchField.title.collapse")}
              <ExpandLessIcon sx={{ fontSize: 18 }} />
            </ButtonMAS>
          )}
        </div>
      }

      <div></div>

      <div className={s.resetSearchButtonContainer}>
        {resetBtn && (
          <ButtonMAS
            className={[s.resetBtn, s.functionalBtn].join(" ")}
            variant="secondary"
            onClick={handleReset}
            disabled={loading}
          >
            {t("component.searchField.title.reset")}
          </ButtonMAS>
        )}
        {searchBtn && (
          <ButtonMAS
            className={[s.searchBtn, s.functionalBtn].join(" ")}
            variant="primary"
            isLoading={loading}
            disabled={loading}
            onClick={() => handleSearch("search")}
          >
            {t("component.searchField.title.search")}
          </ButtonMAS>
        )}
      </div>
    </div>
  );
};

export default React.memo(SearchFieldButtonBar);
